import { axios } from '../util/axios'

const API_ENDPOINT = '/accounts/update'
const API_ENDPOINT_TYPING = '/v1/social/accounts/create'

export default data =>
  axios
    .patch(API_ENDPOINT, data, {
      withCredentials: true,
      headers: {
        'Content-type': 'application/json',
      },
    })
    .then(response => response.data)

export const updateDataAfterSocialLogin = data =>
  axios
    .post(API_ENDPOINT_TYPING, data, {
      withCredentials: true,
      headers: {
        'Content-type': 'application/json',
      },
    })
    .then(response => response.data)
